import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Spinner, Box } from '@chakra-ui/react';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessNewFeatures } from '../../utils/featureAccess';

/**
 * Route guard for GA CRM features (Mortgage Monitor, Leaderboard).
 * Renders the page only for CRM users (via canAccessNewFeatures); everyone
 * else — including authenticated non-CRM Hub users — is redirected to the
 * CRM dashboard. Kept (vs ProtectedRoute) specifically for that CRM-membership
 * check.
 *
 * Note: the page component must be rendered inside `render` here — passing a
 * `component` prop through to <Route> alongside `render` would make React
 * Router ignore `render` entirely (component takes precedence) and bypass
 * the guard.
 */
const NewFeatureRoute = ({ component: Component, children, ...rest }) => {
  const { currentUser, SuperAdmin, Roles, loading } = useAuth();

  if (loading) {
    return (
      <Box w="100%" h="100vh" display="flex" justifyContent="center" alignItems="center">
        <Spinner size="xl" />
      </Box>
    );
  }

  const allowed = !!currentUser && canAccessNewFeatures({ currentUser, SuperAdmin, Roles });

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        allowed ? (
          Component ? <Component {...routeProps} /> : children
        ) : (
          <Redirect
            to={{
              pathname: '/crm/dashboard',
              state: { from: routeProps.location },
            }}
          />
        )
      }
    />
  );
};

export default NewFeatureRoute;
